export const formatDate = (dateString: string, locale: string): string =>
  new Date(dateString).toLocaleDateString(locale)

// Due dates are calendar (date-only) values anchored to UTC midnight so the
// calendar date stays stable regardless of the client timezone (no off-by-one).

// A datepicker's local Date → the UTC-midnight ISO of that calendar day.
export const toUtcDateOnlyIso = (date: Date): string =>
  new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString()

// A stored UTC date-only value → a local Date on the same calendar day (for pickers).
export const fromUtcDateOnly = (dateString: string): Date => {
  const date = new Date(dateString)
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
}

// Format a UTC-anchored date-only value using its UTC calendar date.
export const formatDateOnly = (dateString: string, locale: string): string =>
  new Date(dateString).toLocaleDateString(locale, {timeZone: 'UTC'})

export const formatDateTime = (dateString: string, locale: string): string =>
  new Date(dateString).toLocaleString(locale)

export const formatNumber = (
  value: number | null | undefined,
  locale: string,
  fallback = '—'
): string => (value !== null && value !== undefined ? value.toLocaleString(locale) : fallback)
